<div class="flex flex-column dev" style="background-color: white; min-height: 100vh">
  <cs-nav-bar></cs-nav-bar>
  <div class="flex-grow-1" [ngClass]="constrainWidth ? 'website-wrapper py-3 md:py-5 w-full' : ''">
    <router-outlet></router-outlet>
  </div>
  <cs-footer></cs-footer>
</div>
